<template>
  <div class="bread_cumbs">
    <div class="a_container">
    <v-breadcrumbs :items="items">
      <template v-slot:divider>
        <div class="right-icon">></div>
      </template>
    </v-breadcrumbs>
    </div>
    <div class="b_container">
      <div v-for="link in links" :key="link.TIPOLOGIA">
        <a :href="link.LINK" :class="link.SELECTED + ' ' + link.PRODK " class="link_collection link_collezione_39058"  > {{link.LANG}} </a>
      </div>
    </div>
  </div>
</template>
<script>
//import checkLanguage from "../../../classes/class_check_language";
import get_breadCrumbs from "../../../classes/class_get_breadCrumbs";
export default {
  name: "collectionTitle",
  data() {
    return {
      data: "test",
      hostname: "",
      items: [
        {
    
        },
      ],
      links : "",
    };
  },
  methods: {
 
  },

  async mounted() {
    //let l = new checkLanguage();
    let b = new get_breadCrumbs();
    this.items = b.get_description();
    this.links = b.get_tipologia();
  },
  computed: {
    breadcrumbs___() {
      let t = [
        {
          text: "Collezioni",
          disabled: false,
          href: "https://" + this.hostname + "/collezioni",
        },
        {
          text: "eeee",
          disabled: false,
          href: "https://" + this.hostname + "./collezioni/futura",
        },
        {
          text: "Sospensione",
          disabled: true,
          href: "",
        },
      ];
      return t;
    },
  },
};
</script>
<style scoped>
.v-breadcrumbs__item {
  font-size: 14px !important;
}
.bread_cumbs{
  display: flex;
  flex-direction: row;
    justify-content: space-between;
        max-width: calc( 100vw - ( 100vh * 0.7685 ) - ( ( 100vw - 1153px ) / 2 ) ) !important;
}
.b_container{
    display: flex;
    flex-direction: row;
    margin-top: 17px;

}
.link_collection{
  font-weight: 600 !important;
  margin-left: 20px;
  opacity: 0.6;
}
.link_collection.SELECTED{
  font-weight: 600 !important;
    border-bottom: 1px solid black;
      opacity: 1;
  }

</style>

